import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import { MDCMenuSurface } from '@material/menu-surface';
import { closest } from 'next/javascripts/modules/dom';
import 'next/stylesheets/components/project/list-view-batch-operation-bar.scss';

Component('tr-project-list-view-batch-operation-bar', {
  mixins: [eventListenerMixin],

  properties: {
    selectedGuids: {
      type: Array,
      default: [],
      observer: 'selectedGuidsChanged',
    },
    active: {
      type: Boolean,
      default: false,
    },
    menuSelected: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
      observer: 'titleChanged',
    },
    batchOperationUrl: {
      type: String,
      default: '',
    },
  },

  connected() {
    this.initData();
    this.formContent = this.querySelector('.form-container .content');
    this.listenTo(this.formContent, 'click', this.handleFormContentClick.bind(this));
    this.actionsList = this.querySelector('.actions-container .actions-list');
    this.listenTo(this.actionsList, 'click', this.handleActionsListClick.bind(this));
    this.completionLink = this.querySelector('.update-completion');
    this.menuSurface = this.querySelector('.mdc-menu-surface.actions-more-menu');
    this.mdcMenuSurface = new MDCMenuSurface(this.menuSurface);
    this.listenTo(this.mdcMenuSurface, 'MDCMenuSurface:opened', this.handleMoreMenuOpened.bind(this));
    this.listenTo(this.completionLink, 'click', this.handleCompletionLinkClick.bind(this));
    this.listenTo(this.querySelector('.cancel-btn'), {
      click: this.hideBatchOperationBar.bind(this),
    });
    $(this).on('ajax:beforeSend', '.form-container form', (event, xhr, settings) => {
      // eslint-disable-next-line no-param-reassign
      settings.data += `&${$.param({
        todos_batch_task: { todo_ids: this.selectedGuids },
      })}`;
    });
    $(document).on('ajax:beforeSend',
      '.actions-more-menu .create-sub-todo, .actions-more-menu .update-cc-members, .actions-container .twr-trash, .actions-more-menu .update-custom-fields, .actions-more-menu .update-labels',
      (event, xhr, settings) => {
      // eslint-disable-next-line no-param-reassign
        settings.url += `&${$.param({
          todos_batch_task: { todo_ids: this.selectedGuids },
        })}`;
      });
    $(document).on('ajax:beforeSend', '.form-container .update-cc-members-form',
      (event, xhr, settings) => {
        const isReplace = !this.querySelector('.update-cc-members-form tr-chip-set .mdc-chip[data-value="exist_members"]');
        // eslint-disable-next-line no-param-reassign
        settings.data += `&${$.param({
          todos_batch_task: {
            task_params: {
              is_replace: isReplace,
            },
          },
        })}`;
      });
    $(document).on('ajax:beforeSend', '.form-container .update-labels-form',
      (event, xhr, settings) => {
        const isReplace = !this.querySelector('.update-labels-form tr-chip-set .mdc-chip[data-value="exist_labels"]');
        // eslint-disable-next-line no-param-reassign
        settings.data += `&${$.param({
          todos_batch_task: {
            task_params: {
              replace_labels: isReplace,
            },
          },
        })}`;
      });

    this.listenTo(document, 'mousedown', this.handleDocumentMousedown.bind(this));
    this.listenTo(document, 'keydown', this.handleKeydown.bind(this));
    this.listenTo(this.actionsList, {
      'tr-menu:closed': this.handleMenuClosed.bind(this),
      'tr-menu:selected': () => { this.menuSelected = true; },
    });
    this.listenTo(this, {
      'tr-combo-select-field:change': this.handleComboSelectChange.bind(this),
      'tr-todo-date-field:change': this.handleDateChange.bind(this),
      'tr-todo-attachments:attachmentsChange': this.handleAttachmentsChange.bind(this),
      'tr-grid-todo-title-cell:enter': this.handleTodoTitleCellEnter.bind(this),
      'tr-todo-page-fields:fieldChange': this.handleCustomFieldsChange.bind(this),
      'tr-todo-priority-field:change': this.handlePriorityChange.bind(this),
    });
  },

  initData() {
    this.data = {
      custom_field_value_attributes: {},
    };
  },

  handleCustomFieldsChange(event) {
    const { fieldKey } = event.detail;
    this.data.custom_field_value_attributes[fieldKey] = event.detail.todo[fieldKey] || [];
  },

  handleTodoTitleCellEnter(event) {
    event.stopPropagation();

    const { value } = event.target.contentInput;
    if (!value) return;

    const todoRow = closest(event.target, 'tr-grid-subtodo-row', this);
    this.addNewSubtodoRowAfter({ afterRow: todoRow });
  },

  addNewSubtodoRowAfter({ afterRow }) {
    const newButton = this.querySelector('.link-new-subtodo');
    afterRow.insertAdjacentHTML('afterend', newButton.dataset.template);
    return afterRow.nextElementSibling;
  },

  hideBatchOperationBar() {
    this.selectedGuids = [];
    this.resetFormContainer();
    this.namespacedTrigger('close');
  },

  handleAttachmentsChange({ target }) {
    this.attachGuids = Array.from(target.querySelectorAll('.todo-attachment'))
      .map(attachment => attachment.getAttribute('attachid'));
  },

  handleMenuClosed() {
    if (!this.menuSelected) {
      this.clearActionActiveStatus();
    }
    this.menuSelected = false;
  },

  handleCompletionLinkClick() {
    this.clearActionActiveStatus();
    this.batchSubmit('update_todo', {
      completed: true,
    });
  },

  handlePriorityChange(event) {
    event.stopPropagation();
    const form = this.formContent.querySelector('.update-priority-form');
    if (form) $(form).trigger('submit');
  },

  batchSubmit(action, params = {}) {
    $.ajax({
      url: this.batchOperationUrl,
      method: 'post',
      dataType: 'script',
      contentType: 'application/json; charset=utf-8',
      data: JSON.stringify({
        todos_batch_task: {
          action,
          todo_ids: this.selectedGuids,
          task_params: params,
        },
      }),
    });
  },

  handleFormContentClick(event) {
    if (closest(event.target, '.cancel-btn')) {
      this.resetFormContainer();
    } else if (closest(event.target, '.create-sub-todo-form .exist-content .delete-container')) {
      this.clearExistSubtodos();
    } else if (closest(event.target, '.link-new-subtodo')) {
      this.querySelector('.create-sub-todo-form .subtodos')
        .insertAdjacentHTML('beforeend', event.target.dataset.template);
    } else if (closest(event.target, '.subtodos-container tr-grid-subtodo-row .actions-cell')) {
      this.clearCurrentSubtodo(event.target);
    } else if (closest(event.target, '.update-attachments-form .submit')) {
      this.handleAttachmentsSubmit();
    } else if (closest(event.target, '.create-sub-todo-form .submit')) {
      this.handleSubtodosSubmit();
    } else if (closest(event.target, '.update-custom-fields-form .submit')) {
      this.handleCustomFieldsSubmit();
    }
  },

  clearExistSubtodos() {
    const deleteContainer = $('.create-sub-todo-form .exist-content .delete-container');
    if (!deleteContainer.hasClass('confirm')) {
      deleteContainer.addClass('confirm');
    } else {
      this.querySelector('.exist-content').remove();
      this.deleteSubTodo = true;
    }
  },

  handleAttachmentsSubmit() {
    this.batchSubmit('update_todo', {
      attfile_guids: this.attachGuids,
    });
  },

  handleSubtodosSubmit() {
    const todos = [];
    $('tr-grid-subtodo-row').toArray().forEach((subtodo) => {
      const titleContent = subtodo.querySelector('.todo-content textarea').value;
      if (titleContent) {
        const item = {};
        item.content = titleContent;
        if (subtodo.querySelector('tr-checkbox-field').checked) {
          item.is_completed = true;
        }
        item.due_date = subtodo.querySelector('tr-grid-todo-due-date-cell').value;
        item.assignee_guid = subtodo.querySelector('tr-grid-todo-assignee-cell').value;
        todos.push(item);
      }
    });
    this.batchSubmit('create_sub_todo', {
      delete_sub_todos: this.deleteSubTodo,
      todo_creations: todos,
    });
    this.deleteSubTodo = false;
  },

  handleCustomFieldsSubmit() {
    this.querySelectorAll('.update-custom-fields-form tr-multiple-select-field tr-chip-set').forEach((chipSet) => {
      const existContent = chipSet.querySelector('.mdc-chip[data-replace]');
      if (existContent) {
        const key = `${existContent.dataset.replace}_replace`;
        this.data.custom_field_value_attributes[key] = false;
      }
    });
    Object.keys(this.data.custom_field_value_attributes).forEach((key) => {
      const fieldValue = this.data.custom_field_value_attributes[key];
      if (Array.isArray(fieldValue)) {
        this.data.custom_field_value_attributes[key] = fieldValue.filter(item => item !== 'exist_custom_fields');
      }
    });
    this.batchSubmit('update_todo', this.data);
    this.initData();
  },

  clearCurrentSubtodo(target) {
    const currentSubtodoRow = closest(target, 'tr-grid-subtodo-row');
    if ($('.subtodos-container .subtodos tr-grid-subtodo-row').length > 1) {
      currentSubtodoRow.remove();
    } else {
      const contentInput = currentSubtodoRow.querySelector('tr-grid-todo-title-cell .todo-content textarea');
      contentInput.value = '';
      contentInput.focus();
    }
  },

  handleActionsListClick(event) {
    const { target } = event;
    if (target.classList.contains('twr')) {
      this.resetFormContainer();
      $(target).addClass('active');
    }
  },

  handleMoreMenuOpened() {
    const { left } = this.menuSurface.style;
    if (left) {
      this.menuSurface.style.left = `calc(${left} - 34px)`;
      this.menuSurface.style.bottom = '100px';
    }
  },

  clearActionActiveStatus() {
    this.actionsList.querySelectorAll('.twr').forEach((action) => {
      $(action).removeClass('active');
    });
  },

  handleComboSelectChange(event) {
    event.stopPropagation();
    if (closest(event.target, '.update-assignee-form')) {
      const assigneeForm = this.formContent.querySelector('.update-assignee-form');
      if (assigneeForm) $(assigneeForm).trigger('submit');
    }
  },

  handleDateChange(event) {
    event.stopPropagation();
    const dateForm = this.formContent.querySelector('.update-due-date-form');
    if (dateForm) $(dateForm).trigger('submit');
  },

  handleKeydown(event) {
    const isEscape = event.key === 'Escape' || event.keyCode === 27;
    if (!isEscape) return;

    let menuSurface = '';
    const menu = document.querySelector('.batch-operation-menu.mdc-menu-surface--open');
    if (menu) {
      menuSurface = new MDCMenuSurface(menu);
    }
    const form = this.formContent.querySelector('form');
    if (menuSurface) {
      menuSurface.open = false;
    } else if (form) {
      this.resetFormContainer();
    } else if (this.active) {
      this.hideBatchOperationBar();
    }
  },

  resetFormContainer() {
    this.formContent.innerHTML = '';
    this.title = '';
    this.clearActionActiveStatus();
    $(closest(this.formContent, '.form-container')).removeClass().addClass('form-container');
  },

  selectedGuidsChanged() {
    this.active = this.selectedGuids.length > 0;
    this.querySelector('.count').textContent = this.selectedGuids.length;
  },

  titleChanged() {
    const title = this.querySelector('.form-container .title');
    title.textContent = this.title;
    if (this.title) title.classList.add('show');
    else title.classList.remove('show');
  },

  handleDocumentMousedown(event) {
    event.stopPropagation();
    const { target } = event;
    if (this.contains(target)) return;
    if (!closest(target, '.grid-content')
      && closest(target, 'body > .wrapper')
      && !closest(target, 'tr-todo-page')) {
      this.hideBatchOperationBar();
    }
  },

  disconnected() {
    this.stopListening();
  },
});
